import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Table from '../ogComponent/table';
import { IconArrowRight, IconPlus } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function StdRegular() {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [product, setProduct] = useState([]);
    const userId = localStorage.getItem("userId");
    const [currentPage, setCurrentPage] = useState(1);
    const [formData, setFormData] = useState({
        date: '',
        reason: '',
        punch_duration: 'Quarter Day',
    });

    // Access permissions array from Redux store
    const permissions = useSelector((state) => state.emp.permissions);

    const pagePermissions = ["requestRegularizationID", "showmyRegularizationrequestID", "showallRegularizationrequestID"];

    // Handle page change
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    // Fetch data from API when component mounts
    useEffect(() => {
        if (permissions.includes("showmyRegularizationrequestID")) {
            fetchAttendanceData();
        }
    }, [permissions]);

    const fetchAttendanceData = async () => {
        const userId = localStorage.getItem('userId');
        const accessToken = localStorage.getItem('accessToken');

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API}/api/attendance/attendance-regularization/?employee_id=${userId}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                }
            );

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            const transformedData = result.data.map((item, index) => ({
                SiNo: index + 1,
                date: item.date,
                reason: item.reason,
                punch_type: item.punch_duration,
                status: item.status
            }));
            setProduct(transformedData);
        } catch (error) {
            console.error('Error fetching punch request data:', error);
        }
    };

    const handleClose = () => setShowModal(false);
    const handleShow = () => {
        if (permissions.includes("requestRegularizationID")) {
            setShowModal(true);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const options = [
        { value: "Quarter Day", label: "Quarter Day" },
        { value: "Half Day", label: "Half Day" },
        { value: "Three-quarters day", label: "3 Quarter Day" },
        { value: "Full Day", label: "Full Day" },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!permissions.includes("requestRegularizationID")) return;

        const userId = localStorage.getItem('userId');
        const accessToken = localStorage.getItem('accessToken');

        const payload = {
            employee: userId,
            ...formData
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_API}/api/attendance/attendance-regularization-request/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            console.log('Success:', result);
            handleClose();
            fetchAttendanceData();
        } catch (error) {
            console.error('Error submitting punch request:', error);
        }
    };

    const header = [
        { name: "SiNo", label: "#", active: true },
        { name: "reason", label: "Reason", active: true },
        { name: "date", label: "Date", active: true },
        { name: "punch_duration", label: "Duration", active: true },
        { name: "status", label: "Status", active: true }
    ];

    return (
        <div className='px-4 py-3 w-100'>
            <h3 className='mb-3'>My Punch Requests</h3>
            <div className='py-2 d-flex justify-content-between flex-wrap gap-2'>
                {permissions.includes("requestRegularizationID") && (
                    <button
                        className='btn btn-success'
                        style={{ fontSize: "clamp(12px, 1.4vw, 16px)" }}
                        onClick={handleShow}
                    >
                        Request Punch <IconPlus size={20} />
                    </button>
                )}
                {permissions.includes("showallRegularizationrequestID") && (
                    <button
                        className='btn btn-primary'
                        style={{ fontSize: "clamp(12px, 1.4vw, 16px)" }}
                        onClick={() => navigate('/user/punchreq')}
                    >
                        Show Punch Requests <IconArrowRight />
                    </button>
                )}
            </div>
            {permissions.includes("showmyRegularizationrequestID") ? (
                product.length > 0 ? (
                    <Table
                        product={product}
                        header={header}
                        onRowClick={() => {}}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                ) : (
                    <div
                        className="d-flex justify-content-center align-items-end position-relative"
                        style={{ height: "50vh" }}
                    >
                        <div
                            className="position-absolute top-0 start-0 w-100 h-100"
                            style={{
                                backgroundImage: "url(/assets/file.png)",
                                backgroundSize: "contain",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                opacity: 0.3,
                            }}
                        ></div>
                        <p className="m-0 fw-light fs-5 position-relative">No Punch Requests!</p>
                    </div>
                )
            ) : (
                <p>No permission to view punch requests.</p>
            )}

            {showModal && permissions.includes("requestRegularizationID") && (
                <div className={`modal fade ${showModal ? 'show' : ''}`} style={{ display: showModal ? 'block' : 'none' }} tabIndex="-1" aria-labelledby="requestPunchModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="requestPunchModalLabel">Request Punch</h5>
                                <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="date"
                                            name="date"
                                            value={formData.date}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="reason" className="form-label">Reason</label>
                                        <textarea
                                            className="form-control"
                                            id="reason"
                                            name="reason"
                                            rows="3"
                                            value={formData.reason}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="punch_duration" className="form-label">Punch Duration</label>
                                        <select
                                            className="form-select"
                                            id="punch_duration"
                                            name="punch_duration"
                                            value={formData.punch_duration}
                                            onChange={handleChange}
                                            required
                                        >
                                            {options.map((item) => (
                                                <option key={item.value} value={item.value}>{item.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <button type="submit" className="btn btn-primary">Submit</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModal && permissions.includes("requestRegularizationID") && (
                <div className="modal-backdrop fade show" onClick={handleClose}></div>
            )}
        </div>
    );
}